import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"

class CustomerSupportMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        const navItems = [
            {
                id: 'customer-support',
                label: 'Professional Network',
                link: `/setting/customer-support`
            },
          
            {
                id: 'helpful-documents',
                label: 'Helpful Documents',
                link: `/setting/helpful-documents`
            },
            {
                id: 'helpful-links',
                label: 'Helpful Links',
                link: `/setting/helpful-links`
            }
        ];
        return (
            <React.Fragment>
                <TabNavigation navItems={navItems}

                />
            </React.Fragment>
        )
    }
}
CustomerSupportMenu.propTypes = {
    match: PropTypes.object
}
export default withRouter(CustomerSupportMenu)
